module.exports = __webpack_public_path__ + "img/bg-banner-people-sm.a9bf3e35.png";